import React, { Component } from "react";
import Helmet from "react-helmet";
import Layout from "../layout";
import { Link, graphql, StaticQuery } from "gatsby";
import ChicagoILSkylineLight from "../images/sila-life/illinois/chicago-il-line-drawing.svg";
import PostListing from "../components/Post/PostListing";
import BackgroundImage from "gatsby-background-image";
import ChicagoPostings from "../components/Lever/ChicagoPostings";
import config from "../../data/SiteConfig";

export default () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          silaLife: allFile(
            filter: {
              relativeDirectory: { eq: "sila-life/illinois" }
              extension: { ne: "svg" }
            }
          ) {
            edges {
              node {
                name
                childImageSharp {
                  fluid(quality: 100, maxWidth: 640) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const silaLifePhotos = data.silaLife.edges.map(silaLifePhoto => {
          return {
            name: silaLifePhoto.node.name,
            fluid: silaLifePhoto.node.childImageSharp.fluid,
            path: silaLifePhoto.node.childImageSharp.fluid.src
          };
        });
        const silaOnTheRoof = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-on-the-roof"
        ).path;
        const silaWineCheese = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-rooftop-wine-and-cheese"
        ).path;
        const silaForTheWin = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-for-the-win"
        ).path;
        const silaChicagoBaseball = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-chicago-baseball"
        ).path;
        const coffeePastries = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "coffee-pastries"
        ).path;
        const outdoorScene = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "outdoor-scene"
        ).path;
        const baseballField = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "baseball-field"
        ).path;
        const chicagoCityBg = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "chicago-city-bg"
        ).fluid;
        // const postEdges = data.internshipVideos.edges;
        return (
          <Layout>
            <>
              <Helmet
                title={`Sila Life in Chicago, IL | ${config.siteTitle}`}
              />
              <section className="location-graphic-header chicago">
                <img
                  className="location-graphic"
                  alt="The Chicago, IL skyline"
                  src={ChicagoILSkylineLight}
                />
              </section>
              <section className="st-pad-vert">
                <div className="container text-center">
                  <div className="full">
                    <div className="restrict wide">
                      <h1>Sila Life in Chicago, IL</h1>
                      <p>
                        Our Chicago team revels in the summer months with free
                        festivals, open air markets, and walks that are located
                        all over the city. Consultants are busy supporting
                        clients and growing Sila's newest office in the Windy
                        City. With wide avenues, restaurants, parks, and great
                        sports teams to root for, our team is excited to call
                        Chicago home. When traveling to client sites, our
                        central location in the middle of the country and easy
                        airport access makes for a smooth, quick trip. Browse
                        our <a href="#openings">Chicago openings</a>.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="h3 text-center">We Are Sila Chicago</h2>
                <div className="container make-block">
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaWineCheese}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaOnTheRoof}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaChicagoBaseball}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaForTheWin}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                </div>
              </section>

              <h3 className="h2 text-center xt-pad-top">A Day in the Life</h3>

              <section className="location-story chicago">
                <section className="st-pad-vert dark-on-light">
                  <div className="container">
                    <div className="story-caption">
                      <h3>Work downtown</h3>
                      <p>
                        When we aren’t on-site with our clients, we walk, bus,
                        or take the train to Chicago's downtown, where our
                        office is right on the river. If we don’t grab a pastry
                        and coffee on the way up, we’ll hit up our espresso
                        machine before we start our day.
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="A cup of hot coffee alongside a donut and croissant for a breakfast treat"
                        src={coffeePastries}
                      />
                    </div>
                  </div>

                  <div className="cloud-border-top" />
                </section>

                <section className="st-pad-vert">
                  <div className="container">
                    <div className="story-illustration">
                      <img
                        alt="An outdoor scene showing Chicago's city attractions as well as the surrounding natural beauty"
                        src={outdoorScene}
                      />
                    </div>

                    <div className="story-caption">
                      <h3 className="light-blue-text">Our neighborhood</h3>
                      <p>
                        If we need a break, we head up to the rooftop to take in
                        the beautiful river views or stop for a quick match in
                        the game room. When we want to venture outside,
                        especially in the summer months, we go for a river walk
                        or wander towards Lake Michigan.
                      </p>
                    </div>
                  </div>
                </section>

                <section className="xt-pad-bot light-on-dark">
                  <div className="cloud-border-bottom" />
                  <div className="container">
                    <div className="story-caption">
                      <h3>After hours</h3>
                      <p>
                        After work, we'll stroll down to a rooftop bar for a
                        cocktail, then head to Millennium Park for a concert or
                        picnic with the team. During baseball season, we'll take
                        the red line to Wrigley Field for a Cubs game.
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="A view of a baseball field alongside a team hat and a ball that might be caught by a lucky fan during the game"
                        src={baseballField}
                      />
                    </div>
                  </div>
                </section>
              </section>

              <BackgroundImage
                Tag="section"
                fluid={chicagoCityBg}
                className="location-map chicago-map-bg st-pad-vert no-marg-top"
              >
                <div className="container">
                  <div className="full text-center">
                    <h3>Our Location</h3>
                    <p>
                      We are located at{" "}
                      <a
                        href="https://goo.gl/maps/fxKW5KZejr62"
                        target="_blank"
                      >
                        121 West Wacker, Suite 626, Chicago, IL 60601
                      </a>
                      .
                    </p>
                    <div className="responsive-map-embed">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d95049.05926332803!2d-87.7022535!3d41.8867683!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x880e2cb08d7c9861%3A0x9c1ca8b527cac64f!2s121+W+Wacker+Dr+%23626%2C+Chicago%2C+IL+60601!3m2!1d41.8866619!2d-87.6320417!5e0!3m2!1sen!2sus!4v1533584251661"
                        width="600"
                        height="450"
                        frameborder="0"
                        style={{ border: 0 }}
                        allowfullscreen
                      />
                    </div>
                  </div>
                </div>
              </BackgroundImage>
              <section id="openings">
                <div className="container">
                  <div className="full restrict">
                    <h3 className="text-center margin-bottom">
                      Open Positions in Chicago
                    </h3>
                    <ChicagoPostings />
                  </div>
                </div>

                <div className="container text-center">
                  <div className="full">
                    <p>
                      If you don't see a role that fits your profile, please{" "}
                      <a
                        href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                        target="_blank"
                      >
                        submit a general application
                      </a>
                      .
                    </p>
                    <p>
                      <a
                        href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                        target="_blank"
                        className="button primary"
                      >
                        Apply Now
                      </a>
                    </p>
                  </div>
                </div>
              </section>
            </>
          </Layout>
        );
      }}
    />
  );
};
